var _path, _circle, _circle2, _circle3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBlog = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 -0.5 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M6.535 2.5h-4.58a1 1 0 0 0-.998 1v5a1 1 0 0 0 1 1h1.042a1 1 0 0 1 1 1V12c0 .186.224.28.357.149L6.75 9.788a1 1 0 0 1 .702-.288h3.66a1 1 0 0 0 1-1v-3"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 3.485,
  cy: 7,
  r: 0.5,
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 6.527,
  cy: 7,
  r: 0.5,
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.57,
  cy: 7,
  r: 0.5,
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M7.717 3.379 6.62 5.389l2.282-.387M7.717 3.38 11.772.501l1.185 1.623-4.055 2.878M7.717 3.38l1.185 1.623"
})));
export default SvgBlog;